module.exports = __webpack_public_path__ + "static/img/our-customers-industry-hero.8d13680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-industry-hero.jpg
// module id = DlVH
// module chunks = 0